import { get } from 'lodash';
import getText from 'context/language/getText';

// parser for URQL combined error objects
// https://github.com/FormidableLabs/urql/blob/master/docs/api.md#combinederror-class

// in cases where we can't make the network connection,
// the error.response node should be undefined

export const noNetworkError = getText('loadingError.noConnection');

export const responseStatusIs = (error, value) => get(error, 'response.status', false) === value;
export const mapErrors = error => error.graphQLErrors.map(e => e.message);
export const echoNetworkMsg = error => get(error, 'networkError.message');
export const echoStatusMsg = error => get(error, 'response.statusText', noNetworkError);

export const isNetworkError = error => error.networkError !== undefined;
export const isGraphQLError = error => error.graphQLErrors !== undefined;
export const isRequestError = error => (!responseStatusIs(error, 200));

export const getQueryErrors = error => (isGraphQLError(error) ? mapErrors(error) : []);
export const getNetworkErrors = error => (isNetworkError(error) ? echoNetworkMsg(error) : []);
export const getRequestErrors = error => (isRequestError(error) ? [echoStatusMsg(error)] : []);

// takes in a raw error, returns an array or undefined
const errorParser = rawError => {
  if (!rawError) return undefined;
  const requestError = getRequestErrors(rawError);
  if (requestError.length > 0) {
    return requestError;
  }
  const queryError = getQueryErrors(rawError);
  const networkError = getNetworkErrors(rawError);
  const returnErrors = [...queryError].concat(networkError);
  if (returnErrors.length > 0) {
    return returnErrors;
  }
  return undefined;
};

export default errorParser;
